/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const CODE_SNIPPET_STRINGS = {
  copiedToClipboard: 'Copied to clipboard',
  copyCode: 'Copy code',
};
